function getHost(): string {
  const isLocal = window.location.hostname === "localhost";
  const host = isLocal ? "localhost:8820" : "api.medkus.com";
  return `//${host}`;
}

export const config = {
  host: getHost(),
  uploads: "/public/medkus/uploads/api/",
  apiUrl: `${getHost()}/api`,
};
